(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SentLabResultController', SentLabResultController);

    SentLabResultController.$inject = ['$q', 'CoreService', 'PatientResult', '$uibModal', '$rootScope', 'PopupService',
        'GenericEntityDatatableService'];

    function SentLabResultController($q, CoreService, PatientResult, $uibModal, $rootScope, PopupService,
                                     GenericEntityDatatableService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Sent Lab Results',
            entityClassHumanized: 'Patient Results',
            entityStateName: 'patient-result',
            service: PatientResult,
            serviceMethod: 'getAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'patientName',
                    title: 'Patient Name',
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Barcode',
                    render: function (data) {
                        return data.accessionNumber ? data.accessionNumber : '';
                    }
                },
                {
                    name: null,
                    title: 'Collection Date',
                    render: function (data) {
                        return moment(data.collectionDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: "smsStatus",
                    title: 'Status SMS',
                },
                {
                    name: "smsStatus",
                    title: 'Status SMS',
                },
                {
                    name: "callStatus",
                    title: 'Status CALL',
                },
                {
                    name: "emailStatus",
                    title: 'Status EMAIL',
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        vm.details(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getViewPdfAction(), {
                    action: function (data) {
                        vm.printRangePDFs(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getSendAction(), {
                    name: 'Resend ALL',
                    action: function (data) {
                        return vm.resendAll(data.id);
                    },
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All Results',
                            iClass: 'fa fa-flask',
                            ngClass: function (filter) {
                                return filter.abnormalRange == null ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.abnormalRange = null;
                            }
                        },
                        {
                            name: 'Abnormal',
                            iClass: 'fa fa-thumbs-down',
                            ngClass: function (filter) {
                                return filter.abnormalRange ?
                                    ['active', 'label-danger'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.abnormalRange = true;
                            }
                        },
                        {
                            name: 'Normal',
                            iClass: 'fa fa-thumbs-up',
                            ngClass: function (filter) {
                                return filter.abnormalRange === false ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                filter.abnormalRange = false;
                            }
                        }
                    ],
                },
                {
                    type: 'group',
                    buttons: [
                        {
                            title: '',
                            iClass: 'fa fa-calendar',
                            ngClass: function (filter) {
                                return isCurrentMonth(filter.startDate, filter.endDate) ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                if (isCurrentMonth(filter.startDate, filter.endDate)) {
                                    var endDate = new Date();
                                    var startDate = new Date();
                                    startDate.setDate(endDate.getDate() - 30);

                                    filter.startDate = startDate;
                                    filter.endDate = endDate;
                                } else {
                                    filter.startDate = getCurrentMonthStartDay();
                                    filter.endDate = getCurrentMonthEndDay();
                                }
                            }
                        }
                    ]
                }
            ],
            filters: [
                {
                    name: 'abnormalRange',
                    visible: false
                },
                {
                    name: 'patientName',
                    // title: 'Patient Name',
                    placeholder: 'Patient Name...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'accessionNumber',
                    // title: 'Barcode',
                    placeholder: 'Barcode...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'status',
                    placeholder: 'Status...',
                    type: 'select',
                    values: ['PARTIAL', 'FINAL'],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    visible: true
                },
                {
                    name: 'startDate',
                    // title: 'Start Date',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        var startDate = new Date();
                        startDate.setDate(startDate.getDate() - 30);

                        return startDate;
                    },
                    visible: true
                },
                {
                    name: 'endDate',
                    // title: 'End Date',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                },
            ]
        }

        vm.printRangePDFs = printRangePDFs;
        vm.resendAll = resendAll;
        vm.details = details;

        function resendAll(id) {
            return $q(function (resolve, reject) {
                PatientResult.resendAll({id: id}, function (patientResult) {
                    resolve();
                });
            });
        }

        function printRangePDFs(id) {
            var ids;

            if (id) {
                ids = [id];
            } else {
                ids = getSelectedIds();
            }

            if (ids.length > 0) {
                PatientResult.getAllInOneRangePdf({ids: ids});
            }
        }

        function details(id) {
            PopupService.showPatientResultDet(id);
        }

        function getCurrentMonthStartDay() {
            var nowDate = new Date();

            return new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);
        }

        function getCurrentMonthEndDay() {
            var nowDate = new Date();

            return new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0);
        }

        function isCurrentMonth(startDate, endDate) {

            return moment(startDate).format("MM/DD/YYYY") === moment(getCurrentMonthStartDay()).format("MM/DD/YYYY") &&
                moment(endDate).format("MM/DD/YYYY") === moment(getCurrentMonthEndDay()).format("MM/DD/YYYY");
        }
    }
})();
